import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import { ThemeProps, css, withTheme } from "styled-components";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import React, { ChangeEvent, useEffect, useState } from "react";
import GridContainer, { GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Radio, { RadioStyle } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps, RadioGroupStyle } from "@insite/mobius/RadioGroup";
import TextField from "@insite/mobius/TextField";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { FormFieldStyle } from "@insite/mobius/FormField";
import getColor from "@insite/mobius/utilities/getColor";
import CustomModelRecap from "./ADICustomModalRecap";
import styled from "styled-components";
import ADIColors from "@NA/Utils/ADIColors";
import { addBankAccount } from "@NA/Services/ADIInvoiceRecapBankAccountService";
import Icon from "@insite/mobius/Icon";
import ValidationSuccessIcon from "@NA/Icons/ValidationSuccessIcon";
import WarningIcon from "@NA/Icons/WarningIcon";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Select from "@insite/mobius/Select";

export interface ADINewCreditCardModalRecapStyles {
    editInputWapper?: InjectableCss;
    newListContainer?: InjectableCss;
    cardTypeRadioGroup?: RadioGroupProps;
    errorGrid?: InjectableCss;
    expError?: InjectableCss;
    headingError?: InjectableCss;
    continueButton?: ButtonPresentationProps;
    labelText?: InjectableCss;
    buttonGridItem?: GridItemProps;
    primaryButton?: ButtonPresentationProps;
    secondaryButton?: ButtonPresentationProps;
    container?: InjectableCss;
    tabs?: InjectableCss;
    successMessage?: InjectableCss;
    okButton?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: InjectableCss;
    inputText?: InjectableCss;
    primaryGreyButton?: InjectableCss;
    validationErrorMessage?: InjectableCss;
    radioListGroup?: RadioGroupProps;
    bankAccountHeaderContainer?: InjectableCss;
    selectColumn?: InjectableCss;
    accountTypeColumn?: InjectableCss;
    accountDesColumn?: InjectableCss;
    routingNumberColumn?: InjectableCss;
    accountNumberColumn?: InjectableCss;
    bankAccountDataContainer?: InjectableCss;
    lmsAddressRadioGroup?: InjectableCss;
    radioAddresses?: InjectableCss;
    warningMessage?: InjectableCss;
}

export const adiNewCreditCardModalRecapStyles: ADINewCreditCardModalRecapStyles = {
    container: {
        css: css`
            display: flex;
            padding: 2px;
            border-radius: 6px;
            border: solid 1px ${ADIColors.gray2};
            background: ${ADIColors.white};
            max-width: 400px;
            width: 100% !important;
        `,
    },
    tabs: {
        css: css`
            padding: 7px 30px;
            border-radius: 6px;
            border: 0;
            background-color: ${ADIColors.white};
            text-align: center;
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            line-height: 22px;
            font-weight: normal;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            transition: all 0.1s ease;
            position: relative;
            overflow: visible;
            flex: 1;

            &:nth-of-type(2) {
                margin-left: 10px;
            }

            &:last-child::after {
                display: none;
            }

            &.active {
                background-color: ${ADIColors.darkBlue1};
                color: ${ADIColors.white};
                font-weight: 600;
            }
        `,
    },
    newListContainer: {
        css: css`
            max-width: 50rem !important;
            margin-top: 10px;
            > ${GridOffset} {
                > ${GridItemStyle} {
                    display: flex;
                    flex-direction: row;
                    padding-top: 16px;
                    padding-bottom: 0px;
                    // margin-bottom: 1rem;
                    > ${TypographyStyle} {
                        margin-bottom: 2px;
                    }
                }
            }
        `,
    },
    labelText: {
        css: css`
            min-height: 19px;
            font-weight: 800;
            line-height: normal;
            color: ${getColor("text.main")};
        `,
    },
    cardTypeRadioGroup: {
        css: css`
            flex-direction: row;
            justify-content: center;
            margin-bottom: 0;
            legend {
                font-size: ${getProp("theme.typography.headerSecondary.size")};
                font-weight: bold;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        justify-content: start;
                        gap: 8px;
                    `,
                    css`
                        flex-direction: column;
                        justify-content: start;
                        gap: 8px;
                    `,
                    css`
                        flex-direction: row;
                        justify-content: center;
                    `,
                    css`
                        flex-direction: row;
                        justify-content: center;
                    `,
                    css`
                        flex-direction: row;
                        justify-content: center;
                    `,
                ])}
            > ${RadioStyle} {
                margin-top: 0px !important;
                label {
                    font-size: ${getProp("theme.typography.h6.size")};
                    font-weight: normal;
                }
            }
        `,
    },
    editInputWapper: {
        css: css`
            display: flex;
            margin-bottom: 3px;
            width: 100%;
            gap: 15px;
        `,
    },
    errorGrid: {
        css: css`
            ${FormFieldStyle} {
                ${TypographyStyle} {
                    color: ${getColor("danger")};
                }
            }
            ${RadioGroupStyle} {
                legend {
                    color: ${getColor("danger")} !important;
                }
            }
        `,
    },
    expError: {
        css: css`
            color: ${getColor("danger")} !important;
        `,
    },
    headingError: {
        css: css`
            color: ${getColor("danger")};
        `,
    },
    continueButton: {
        css: css`
            border-radius: 4px;
            width: 160px;
        `,
    },
    buttonGridItem: {
        css: css`
            flex-direction: row !important;
            justify-content: end;
            gap: 10px;
            margin-bottom: 15px !important;
            width: 100% !important;
            padding: 0px;
            flex-basis: 44%; !important;
        `,
    },
    primaryButton: {
        css: css`
            border-radius: 4px;
            flex: 1;
        `,
    },
    secondaryButton: {
        css: css`
            border-radius: 4px;
            flex: 1;
        `,
    },
    primaryGreyButton: {
        css: css`
            border-radius: 4px;
            flex: 1;
            opacity: 0.5;
            cursor: default;
            outline: none;
            border-color: ${ADIColors.primaryDisabledColor} !important;
            background-color: ${ADIColors.primaryDisabledColor};
            &:hover {
                background-color: ${ADIColors.primaryDisabledColor} !important;
            }
            &:focus {
                outline-color: unset;
            }
        `,
    },
    successMessage: {
        css: css`
            display: inline-flex;
            width: 100%;
            height: 54px;
            margin: 10px 12px 16px 0px;
            font-size: 14px;
            font-weight: 800;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.29;
            letter-spacing: normal;
            color: ${ADIColors.black};
        `,
    },
    okButton: {
        css: css`
            border-radius: 4px;
            width: 100%;
            margin-bottom: 15px;
        `,
    },
    centeringWrapper: {
        css: css`
            width: 100%;
            padding: 30px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    inputText: {
        css: css`
            padding: 10px !important;
        `,
    },
    validationErrorMessage: {
        css: css`
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
            color: ${ADIColors.black} !important;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            gap: 8px;
        `,
    },
    bankAccountDataContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            align-content: center;
            align-items: baseline;
            justify-content: center;
            width: 50%;
            border: 1px solid #ddd;
            border-radius: 8px;
            padding: 10px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 10px 20px;
                            height: 356px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    warningMessage: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: left;
        `,
    },
    selectColumn: {
        css: css`
            width: 10%;
        `,
    },
    lmsAddressRadioGroup: {
        css: css`
            fieldset {
                display: flex;
                flex-direction: row;
                width: 100%;
                justify-content: center;
                align-items: flex-start;
                gap: 50px;
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                                gap: 10px;
                            `,
                    ],
                    "max",
                );
            }}
                div: {
                }
            }
        `,
    },
    radioAddresses: {
        css: css`
            width: 100%;
            padding-left: 34px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-left: 5px;
                            height: inherit;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
};

const mapStateToProps = (state: ApplicationState) => {
    return {
        countries: getCurrentCountries(state),
    };
};

export interface state {
    id: string;
    name: string;
    abbreviation: string;
}

export interface country {
    id: string;
    name: string;
    abbreviation: string;
    states: state | null;
}
export interface originalAddress {
    attention: string | null;
    companyName: string;
    address1: string | null;
    address2: string | null;
    address3: string | null;
    city: string | null;
    state: state | null;
    postalCode: string | null;
    country: country | null;
    phone: string | null;
}
export interface proposedAddress {
    validated: string;
    validationScore: number;
    attentionName: string;
    companyName: string;
    address1: string;
    address2: string;
    address3: string;
    city: string;
    county: string;
    stateProv: string;
    postalCode: string;
    country: string;
    phoneNumber: string;
    faxNumber: string;
    emailAddress: string;
    carrierAccountNumber: string;
    taxID: string;
    taxIDType: number;
    countryID3: string;
    countryCode: string;
    countryName: string;
    addressFormat: string;
    currencyID: string;
    cleanPostalCode: string;
    residentialFg: string;
    cityCode: string;
    internalReferenceID: string;
}
export interface address {
    originalAddress: originalAddress;
    proposedAddress: proposedAddress;
    validationMessage: string;
    compCode: string | null;
    custNumber: string | null;
    suffix: string | null;
    recordCnt: string | null;
    requestId: string | null;
    totalCount: string | null;
    properties: string | null;
    returnCode: string;
    returnMsg: string;
    isSuccessStatusCode: boolean;
}
interface customerData {
    email: string;
    customerName: string;
    accountDescription: string;
    accountType: string;
    bankAccountNumber: string;
    routineNumber: string;
    termsAgreed: string;
}

interface OwnProps {
    isFormError?: boolean;
    isApiError?: boolean;
    openModal: boolean;
    closeModal: Function;
    initiatedByUserName?: string;
    closeAddressModal?: Function;
    address?: address;
    handleSuggestionSelection: Function;
    title: string;
    isEdit?: boolean;
    warningMessage?: string;
    nickName?: string;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ThemeProps<BaseTheme>;

const styles = adiNewCreditCardModalRecapStyles;

const SuccessMessage = styled.div`
    padding: 2px;
    display: flex;
    margin: 5px 0 7px;
    gap: 15px;
    margin-bottom: 15px;
    margin-top: 15px;
    align-items: center;
`;

const ADINewAccountAddressSuggestionModalRecap = ({
    closeModal,
    openModal,
    isFormError,
    address,
    handleSuggestionSelection,
    title,
    isEdit,
    warningMessage,
    nickName,
}: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isApiErrorMessage, setIsApiErrorMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState("provided");

    const handleRadioChange = (value: string) => {
        setSelectedAddress(value);
    };
    return (
        <CustomModelRecap
            headline={translate(title)}
            subheading={""}
            isOpen={openModal}
            errorStyle={isFormError ? true : false}
            handleClose={closeModal}
        >
            <>
                {isApiErrorMessage && (
                    <Typography color="danger" size={14}>
                        {isApiErrorMessage}
                    </Typography>
                )}

                {!isSuccess && openModal && (
                    <GridContainer {...styles.newListContainer}>
                        <GridItem width={12}>
                            <Typography color="danger" size={14} {...styles.warningMessage}>
                                <Icon src={WarningIcon} />{" "}
                                {translate(
                                    warningMessage !== "" && warningMessage !== undefined
                                        ? warningMessage
                                        : translate(
                                            "We couldn't find the address you provided. We've suggested the closest match. Please choose whether you want to use the address you provided or the one we suggest",
                                        ),
                                )}
                            </Typography>
                        </GridItem>

                        <GridItem width={12} id="LMSAddressValidationForm" {...styles.lmsAddressRadioGroup}>
                            <RadioGroup
                                name="bankAccount"
                                {...styles.radioListGroup}
                                value={selectedAddress}
                                onChangeHandler={e => handleRadioChange(e.target?.value)}
                            >
                                <StyledWrapper {...styles.bankAccountDataContainer}>
                                    <Radio key="Provided" value="provided">
                                        <b>Address Provided</b>
                                    </Radio>
                                    <StyledWrapper {...styles.radioAddresses}>
                                        <div>{address?.originalAddress?.companyName}</div>
                                        <div>{address?.originalAddress?.address1}</div>
                                        {address?.originalAddress?.address2 && (
                                            <div>{address?.originalAddress?.address2}</div>
                                        )}
                                        <div>
                                            {address?.originalAddress?.city},{" "}
                                            {address?.originalAddress?.state?.abbreviation}{" "}
                                            {address?.originalAddress?.postalCode}
                                        </div>
                                        <div>{address?.originalAddress?.country?.abbreviation}</div>
                                        <div>Nickname: {nickName?.toUpperCase()}</div>
                                    </StyledWrapper>
                                </StyledWrapper>

                                <StyledWrapper {...styles.bankAccountDataContainer}>
                                    <Radio key="suggested" value="suggested">
                                        <b>Suggested Address</b>
                                    </Radio>
                                    <StyledWrapper {...styles.radioAddresses}>
                                        <div>
                                            {address?.originalAddress?.companyName.toLowerCase() ===
                                                address?.proposedAddress?.companyName.toLowerCase() ? (
                                                address?.proposedAddress?.companyName
                                            ) : (
                                                <b>{address?.proposedAddress?.companyName}</b>
                                            )}
                                        </div>
                                        <div>
                                            {address?.originalAddress?.address1 !== null &&
                                                address?.originalAddress?.address1.toLowerCase() ===
                                                address?.proposedAddress?.address1.toLowerCase() ? (
                                                address?.proposedAddress?.address1
                                            ) : (
                                                <b>{address?.proposedAddress?.address1}</b>
                                            )}
                                        </div>
                                        {address?.proposedAddress?.address2 && (
                                            <div>
                                                {address?.originalAddress?.address2 !== null &&
                                                    address?.originalAddress?.address2.toLowerCase() ===
                                                    address?.proposedAddress?.address2.toLowerCase() ? (
                                                    address?.proposedAddress?.address2
                                                ) : (
                                                    <b>{address?.proposedAddress?.address2}</b>
                                                )}
                                            </div>
                                        )}
                                        <div>
                                            {address?.originalAddress?.city !== null &&
                                                address?.originalAddress?.city.toLowerCase() ===
                                                address?.proposedAddress?.city.toLowerCase() ? (
                                                address?.proposedAddress?.city
                                            ) : (
                                                <b>{address?.proposedAddress?.city}</b>
                                            )}
                                            ,{" "}
                                            {address?.originalAddress?.state?.abbreviation ===
                                                address?.proposedAddress?.stateProv ? (
                                                address?.proposedAddress?.stateProv
                                            ) : (
                                                <b>{address?.proposedAddress?.stateProv}</b>
                                            )}{" "}
                                            {address?.originalAddress?.postalCode ===
                                                address?.proposedAddress?.postalCode ? (
                                                address?.proposedAddress?.postalCode
                                            ) : (
                                                <b>{address?.proposedAddress?.postalCode}</b>
                                            )}
                                        </div>
                                        <div>{address?.proposedAddress?.country}</div>
                                        <div>Nickname: {nickName?.toUpperCase()}</div>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </RadioGroup>
                        </GridItem>
                        <GridItem
                            width={12}
                            css={css`
                                align-items: center;
                            `}
                        >
                            {!isLoading && (
                                <GridItem width={6} {...styles.buttonGridItem}>
                                    {/* {isEdit && */}
                                    <Button
                                        onClick={() => {
                                            closeModal();
                                        }}
                                        variant="secondary"
                                        {...styles.primaryButton}
                                    >
                                        {translate("Edit")}
                                    </Button>
                                    {/* } */}
                                    <Button
                                        onClick={() => {
                                            closeModal();
                                            handleSuggestionSelection(selectedAddress);
                                        }}
                                        variant="primary"
                                        {...styles.primaryButton}
                                    >
                                        {translate("Save")}
                                    </Button>
                                </GridItem>
                            )}
                            {isLoading && (
                                <StyledWrapper {...styles.centeringWrapper}>
                                    <LoadingSpinner {...styles.spinner} />
                                </StyledWrapper>
                            )}
                        </GridItem>
                    </GridContainer>
                )}
            </>
        </CustomModelRecap>
    );
};

export default connect(mapStateToProps)(withTheme(ADINewAccountAddressSuggestionModalRecap));
